<template>
	<v-alert type="info" dismissible prominent v-if="status">
		{{ status }}
	</v-alert>
</template>

<script>
export default {
	props: {
		message: String,
	},
	computed: {
		status() {
			return this.message ?? this.$page.props.status;
		},
	},
};
</script>